import React, {useMemo} from "react";
import { Button } from "react-bootstrap";
import objectPath from "object-path";
import SVG from "react-inlinesvg";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../_helpers";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {SearchDropdown} from "../extras/dropdowns/search/SearchDropdown";
import {UserNotificationsDropdown} from "../extras/dropdowns/UserNotificationsDropdown";
import {QuickActionsDropdown} from "../extras/dropdowns/QuickActionsDropdown";
import {MyCartDropdown} from "../extras/dropdowns/MyCartDropdown";
import {LanguageSelectorDropdown} from "../extras/dropdowns/LanguageSelectorDropdown";
import {QuickUserToggler} from "../extras/QuiclUserToggler";
import {FactorySelectionDropdown} from "../../../../app/components/extras/dropdown/FactorySelectionDropdown";
import {RoleDropdown} from "../../../../app/components/extras/RoleDropdown/RoleDropdown";
import { UserMenu } from "./header-menu/UserMenu"
import { getUserAccessLevel, getUserAccessLevelReal } from "../../../../app/helpers/role";
import { Manual } from "../../../../app/Manual";
import { Dropdown } from "react-bootstrap";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { checkIsActive } from "../../../_helpers";
import HelpIcon from '@material-ui/icons/Help';
import { Link } from 'react-router-dom';
import env from "../../../../env";

const changeFactoryComponentAccessLevel = 9;
const changeRoleComponentAccessLevel = 10;

export function Topbar() {

  const location = useLocation();
  const getMenuItemActive = (url) => {
      return checkIsActive(location, url) ? "menu-item-active" : "";
  }

  const uiService = useHtmlClassService();
    const userAcessLevel = getUserAccessLevelReal();
  const userHasPermissionToChangeFactory = userAcessLevel >= changeFactoryComponentAccessLevel;
    const userHasPermissionToChangeAccess = userAcessLevel >= changeRoleComponentAccessLevel;
  /*const layoutProps = useMemo(() => {
    return {
      viewSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      viewNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      viewQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      viewCartDisplay: objectPath.get(uiService.config, "extras.cart.display"),
      viewQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      viewLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
    };
  }, [uiService]);*/

  return (
      <div className="topbar">
          {env.ENVIRONMENT === 'PreProd' ?
              <div className="topbar-item">
                  <p style={{ fontSize: '30px', color: "black", marginTop: "5%" }}>Ambiente Preprod</p>
              </div>
              : null
          }
      <div className="topbar-item">
       <Manual />
      </div>
      <div className="topbar-item">
      <div
        id="kt_header_menu"
        className={`header-menu header-menu-mobile ${uiService.getClasses("header_menu", true)}`}
      >
        <ul className={`menu-nav ${uiService.getClasses("header_menu_nav", true)}`}>
        {/*Classic submenu*/}
            {/*begin::1 Level*/}
            <li
                data-menu-toggle={objectPath.get(uiService.config, "header.menu.desktop.toggle")}
                aria-haspopup="true"
                className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive('/google-material')}`}>
                <NavLink className="menu-link menu-toggle" to="/google-material">
                    <span className="menu-text">Manuais em vídeos</span>
                    <i className="menu-arrow"></i>
                </NavLink>
                <div className="menu-submenu menu-submenu-classic menu-submenu-left">
                    <ul className="menu-subnav">
                        {/*begin::2 Level*/}
                        <li
                            className={`menu-item menu-item-submenu ${getMenuItemActive('/google-material/inputs')}`}
                            data-menu-toggle="hover"
                            aria-haspopup="true"
                        >
                            <NavLink className="menu-link menu-toggle" to="/google-material/inputs">
                                <span className="svg-icon menu-icon">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/layout/Layout-grid.svg")} />
                                </span>
                                <span className="menu-text">
                                  Na matriz
                                </span>
                                <i className="menu-arrow" />
                            </NavLink>
                            <div className={`menu-submenu menu-submenu-classic menu-submenu-right`}>
                                <ul className="menu-subnav">
                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-74">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video de como usar o "Ver PDIS publicos"</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-73">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video de como revisar nivel de colaborador</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-72">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video sobre o registro coaching</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-71">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video sobre a introdução ao menu lateral e pagina home</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-70">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video de como gerenciar as estruturas de uma fabrica</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-69">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video de como gerenciar competencias"</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-68">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video de como planejar PDI (consolidar nivel, mudar data, criar do zero, entre outros)</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                     <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-67">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video de como baixar o manual e guia rapido de como usa-lo</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-66">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video de como alterar nível de acesso de um colaborador</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                </ul>
                            </div>
                        </li>
                        {/*end::2 Level*/}

                        {/*begin::2 Level*/}
                        <li
                            className={`menu-item menu-item-submenu ${getMenuItemActive('/google-material/navigation')}`}
                            data-menu-toggle="hover"
                            aria-haspopup="true"
                        >
                            <NavLink className="menu-link menu-toggle" to="/google-material/navigation">
                                <span className="svg-icon menu-icon">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Book.svg")} />
                                </span>
                                <span className="menu-text">
                                    Na Biblioteca
                                </span>
                                <i className="menu-arrow" />
                            </NavLink>
                            <div className={`menu-submenu menu-submenu-classic menu-submenu-right`}>
                                <ul className="menu-subnav">
                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-63">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Como usar o "Meus Treinamentos"</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-62">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Como criar um ID Card</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-61">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Como usar o Funil</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-60">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Como usar o Fluxo de Aprovação</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-59">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Como usar o Editor</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-58">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Como criar uma LPP</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-57">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Como criar uma DTP</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-56">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Como consultar DTP LPP e ID Card</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                     <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-55">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Como usar o "Ache Aqui"</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}
                                </ul>
                            </div>
                        </li>
                        {/*end::2 Level*/}

                        {/*begin::2 Level*/}
                        <li
                            className={`menu-item menu-item-submenu ${getMenuItemActive('/google-material/navigation')}`}
                            data-menu-toggle="hover"
                            aria-haspopup="true"
                        >
                            <NavLink className="menu-link menu-toggle" to="/google-material/navigation">
                                <span className="svg-icon menu-icon">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Home/stairs.svg")} />
                                </span>
                                <span className="menu-text">
                                    Nas Rotas
                                </span>
                                <i className="menu-arrow" />
                            </NavLink>
                            <div className={`menu-submenu menu-submenu-classic menu-submenu-right`}>
                                <ul className="menu-subnav">
                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-79">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video de como responder minhas questões de rotas</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-78">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video de como criar "Rota Linha"</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-77">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video de criar as questões nas rotas</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-76">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video de como criar atividade em rotas</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}

                                    {/*begin::3 Level*/}
                                    <li className={`menu-item ${getMenuItemActive('/google-material/inputs/transfer-list')}`}>
                                        <a className="menu-link" href="https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-80">
                                            <i className="menu-bullet menu-bullet-dot"><span /></i>
                                            <span className="menu-text">Manual em video de como criar minhas rotas</span>
                                        </a>
                                    </li>
                                    {/*end::3 Level*/}
                                </ul>
                            </div>
                        </li>
                        {/*end::2 Level*/}
                    </ul>
                </div>
            </li>
            {/*end::1 Level*/}
          </ul>
      </div>
      </div>
      {/*layoutProps.viewSearchDisplay && <SearchDropdown/>*/}

      {/*layoutProps.viewNotificationsDisplay && <UserNotificationsDropdown/>*/}

      {/*layoutProps.viewQuickActionsDisplay && <QuickActionsDropdown/>*/}

      {/*layoutProps.viewCartDisplay && <MyCartDropdown/>*/}

      {/*layoutProps.viewQuickPanelDisplay && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="quick-panel-tooltip">Quick panel</Tooltip>}
        >
          <div
            className="topbar-item"
            data-toggle="tooltip"
            title="Quick panel"
            data-placement="right"
          >
            <div
              className="btn btn-icon btn-clean btn-lg mr-1"
              id="kt_quick_panel_toggle"
            >
              <span className="svg-icon svg-icon-xl svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Layout/Layout-4-blocks.svg"
                  )}
                />
              </span>
            </div>
          </div>
        </OverlayTrigger>
                  )*/}

                <div className = "App mt-5">
                <Link
                            to={{
                              pathname: `/HelpIndex`,
                              state: {},
                            }}
                          >
                            <Button
                              variant="success"
                              size="sm"
                            ><HelpIcon className="mr-2"/>Ajuda</Button>
                </Link>
                </div>


      {/*layoutProps.viewLanguagesDisplay && <LanguageSelectorDropdown/>*/}
        { userHasPermissionToChangeAccess ?
            <RoleDropdown /> : ''
        }
        { userHasPermissionToChangeFactory ?
            <FactorySelectionDropdown /> : ''
        }
        
      {/*layoutProps.viewUserDisplay && <QuickUserToggler/>*/}

      <UserMenu/>

    </div>
  );
}
